<div layout="column" flex id="content" class="page-content">
  <div class="d-flex space-between p-b-30">
    <div class="header-wrapper">
      <span class="page-header">Approval</span>

      <column-chips-popover
        *ngIf="noDataAvailable"
        [defaultDisplayedColumns]="displayedColumns"
        (changeDisplayedColumns)="changeDisplayedColumns($event)"
      ></column-chips-popover>
    </div>
  </div>

  <div>
    <data-table
      [displayedColumns]="displayedColumns"
      statusFilter="Approval"
      [dataSource]="dataSource"
      (noDisplayDataEmitter)="handleNoTableData($event)"
    ></data-table>
  </div>
</div>
